import MicroModal from "micromodal"

const cmpStockExchangePopup = {
	component: null,

	init: function (element) {
		const _ = this
		_.component = element

		const modals = _.component.querySelectorAll(".cmp-stockexchange-modal .modal")
		const closebutton = document.querySelector(".cmp-stockexchange-modal__close")

		MicroModal.init({
			onShow: (modal) => console.info(`${modal.id} is shown`),
			onClose: (modal) => console.info(`${modal.id} is hidden`),
			openTrigger: "data-custom-open",
			closeTrigger: "data-custom-close",
			openClass: "is-open",
			disableScroll: true,
			disableFocus: false,
			awaitOpenAnimation: false,
			awaitCloseAnimation: false,
			debugMode: false,
		})

		closebutton.addEventListener("click", async function () {
			document.querySelector(".cmp-stockexchange-modal .modal").classList.add('micromodal-slide')
			document.querySelector("#stockExchangePopupModal-content").innerHTML = ""
		})
	}
}

export default cmpStockExchangePopup
